// @flow
import React from 'react';
import { findIndex } from 'lodash/fp';
import { Link } from 'react-router-dom';
import TabBar from '~/components/widgets/tabs';
import type { TabRenderer } from '~/components/widgets/tabs';
import { withRouter } from 'react-router';
import type { Location } from 'react-router';

type Props = {
    children: React$Element<typeof TabBar>,
    tabGroup: string,
    location: Location
};

type State = {
    tab: number
};

class QuerystringTabManager extends React.Component<Props, State> {
    state = {
        tab: 0
    };

    tabChange = (index: number) => {
        this.setState({
            tab: index
        });
    };

    setupCurrentTab = ({ tabGroup, children, location }: Props) => {
        const qs = new URLSearchParams(location.search);
        const qsVal = qs.get(tabGroup);
        const index = findIndex(c => c.props.name === qsVal, children.props.children);
        this.tabChange(index >= 0 ? index : this.state.tab);
    };

    renderTab: TabRenderer = ({ maybeIcon, label, onClick, name }) => {
        return (
            <Link onMouseDown={onClick} to={{ search: `?${this.props.tabGroup}=${name}` }}>
                {maybeIcon}
                {label}
            </Link>
        );
    };

    componentDidMount() {
        this.setupCurrentTab(this.props);
    }

    componentWillReceiveProps(nextProps: Props) {
        this.setupCurrentTab(nextProps);
    }

    render() {
        return React.cloneElement(this.props.children, {
            onTabChange: this.tabChange,
            selectedTabIndex: this.state.tab,
            renderTab: this.renderTab
        });
    }
}

export default withRouter(QuerystringTabManager);



// WEBPACK FOOTER //
// ./src/components/widgets/querystring-tab-manager/index.js